import React, { useContext } from 'react';

import { FlexDiv, GenericDiv, GenericP, Heading, ResponsiveContainer } from '../../../../common/Styles';
import { WhyWrapper, BenefitsIcons, BenefitWrap } from './whyExpenseStyles';
import { BorderWrap } from '../../Styles';

import { WhyTxt } from '../../config';
import { isMobileContext } from '../../../../UtilityComponents/Util';
import DisplayContext from '../../../../UtilityComponents/displayContext';

const WhyExpense = () => {
	const { heading: headTxt, benefits = [] } = WhyTxt;
	const displayName = useContext(DisplayContext).isMobile;
	const isMobile = isMobileContext(displayName);
	return (
		<WhyWrapper>
			<ResponsiveContainer isNoBTPadd>
				<BorderWrap />
				<Heading as={isMobile ? 'h3' : 'h1'} dangerouslySetInnerHTML={{ __html: headTxt }} />
				<FlexDiv className='custom-scroll noshow' directionInMobile='column' justify={benefits.length > 2 ? 'space-between' : 'center'} top_M={isMobile ? '24' : '78'} text_align='center'>
					{benefits.map((benefit, i) => (
						<BenefitWrap key={i}>
							<BenefitsIcons icon={benefit.icon} />
							<GenericDiv top_M={isMobile ? '0' : '35'} $width={isMobile ? '70%' : '100%'}>
								<Heading f_weight='900' as={isMobile ? 'h4' : 'h3'}>
									{benefit.heading}
								</Heading>
								<GenericP fsize={isMobile ? '12px' : '1.285rem'} text_align={isMobile ? 'left' : 'center'} top_M={isMobile ? '6px' : '16'}>{benefit.desc}</GenericP>
							</GenericDiv>
						</BenefitWrap>))}
				</FlexDiv>
			</ResponsiveContainer>
		</WhyWrapper>
	);
};

export default WhyExpense;
